
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiLightBacklightButtonsOff as ObiLightBacklightButtonsOffElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-light-backlight-buttons-off.js';
 
 
 

 
 export const ObiLightBacklightButtonsOff = createComponent({
   react: React,
   tagName: 'obi-light-backlight-buttons-off',
   elementClass: ObiLightBacklightButtonsOffElement,
   events: {
     
   }
  });
 
 